// extracted by mini-css-extract-plugin
module.exports = {"form":"PhotoCommentsForm_form__1ObVk","textarea":"PhotoCommentsForm_textarea__30xsk","button":"PhotoCommentsForm_button__1PvYg","latir":"PhotoCommentsForm_latir__1V0ei"};